
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M137.41 36.15A11.26 11.26 0 00127.58 53L101.2 78.67a10.92 10.92 0 00-10.82-.15L70.81 57.59a11.34 11.34 0 10-20.43.5L17.65 92.42a11.19 11.19 0 00-5.06-1.24 11.34 11.34 0 1011.33 11.33 11.15 11.15 0 00-1.62-5.75l32.44-34a11.14 11.14 0 0011.93-.27L85.82 83A11.32 11.32 0 10107 88.5a11.16 11.16 0 00-1.36-5.27l26.51-25.77a11.16 11.16 0 005.27 1.36 11.34 11.34 0 000-22.67z","fill":"#fff"}})])
          )
        }
      }
    